import React from 'react';
import PropTypes from 'prop-types';
import { Title, Column, ColumnLayout, Controls, Control } from 'features/App';
import AutoSyncStatus from 'components/AutoSyncStatus';
import FeatureNotSupported from 'components/FeatureNotSupported';
import Message from 'components/Message';

import SchedulesBoardTypeFilter from './SchedulesBoardTypeFilterContainer';
import SchedulesBoardStatusFilter from './SchedulesBoardStatusFilterContainer';
import ScheduleBoardClassFilter from './ScheduleBoardClassFilter/ScheduleBoardClassFilterContainer';
import ScheduleBoardDurationFilter from './ScheduleBoardDurationFilter/ScheduleBoardDurationFilterContainer';
import ScheduleBoardInstructorFilter from './ScheduleBoardInstructorsFilter/ScheduleBoardInstructorsFilterContainer';
import SchedulePreview from './SchedulePreview/SchedulePreviewContainer';
import SchedulesList from './SchedulesList/SchedulesListContainer';
import { AddScheduleButton } from '../AddScheduleButton';
import DateControls from '../DateControlsContainer';
import messages from '../Schedules.messages';

const SchedulesBoard = ({ featureIsSupported, venueId, startDate }) => {
  return (
    <ColumnLayout dataCypress="schedules-board">
      <Column className="column-layout__column--lg-2/3" name="list" type="flush">
        <Message message={messages.board.title} as={Title} />

        {!featureIsSupported ? (
          <Controls>
            <Control type="trough">
              <FeatureNotSupported />
            </Control>
          </Controls>
        ) : (
          <>
            <Controls>
              <Control type="filter">
                <DateControls isControl />
              </Control>
              <Control type="filter">
                <SchedulesBoardStatusFilter />
              </Control>
              <Control type="filter">
                <SchedulesBoardTypeFilter />
              </Control>
              <Control type="filter">
                <ScheduleBoardClassFilter />
              </Control>
              <Control type="filter">
                <ScheduleBoardDurationFilter />
              </Control>
              <Control type="filter">
                <ScheduleBoardInstructorFilter />
              </Control>
              <Control type="trough">
                <AutoSyncStatus />
              </Control>
              <Control type="button">
                <AddScheduleButton venueId={venueId} startDate={startDate} />
              </Control>
            </Controls>

            <SchedulesList />
          </>
        )}
      </Column>
      <Column className="column-layout__column--lg-1/3 lg-ml-l" name="preview" type="flush">
        {featureIsSupported && <SchedulePreview />}
      </Column>
    </ColumnLayout>
  );
};

SchedulesBoard.propTypes = {
  featureIsSupported: PropTypes.bool,
  venueId: PropTypes.number,
  startDate: PropTypes.instanceOf(Date),
};

export default SchedulesBoard;
